export default __webpack_public_path__ + "static/rocketroute_logo-5e88060a7906154370729636a639f5b1.png";